import { OpeningDay, OpeningDayHours, OpeningHours } from '../types/surgery';

export const OPENING_DAYS: OpeningDay[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
  'Bank Holidays',
];

const MISSING_TIMES = 'Enter an opening and a closing time';
const CLOSES_BEFORE_OPENING = 'Closing time must be after opening time';
const INVALID_BREAKS = 'Breaks must fit within opening hours, end after they start and not overlap';

const breaksAreValid = ({ open, close, breaks }: OpeningDayHours) => {
  const byStart = [...breaks].sort((a, b) => a.start.localeCompare(b.start));

  return byStart.every(
    (current, index) =>
      current.start < current.end &&
      current.start >= (open as string) &&
      current.end <= (close as string) &&
      (index === 0 || current.start >= byStart[index - 1].end),
  );
};

const dayError = (day: OpeningDayHours): string | undefined => {
  if (!day.isOpened) return undefined;
  if (!day.open || !day.close) return MISSING_TIMES;
  if (day.close <= day.open) return CLOSES_BEFORE_OPENING;
  if (!breaksAreValid(day)) return INVALID_BREAKS;
  return undefined;
};

export const openingHoursErrors = (hours?: OpeningHours | null): Partial<Record<OpeningDay, string>> =>
  OPENING_DAYS.reduce<Partial<Record<OpeningDay, string>>>((errors, name) => {
    const day = hours?.[name];
    const error = day && dayError(day);
    return error ? { ...errors, [name]: error } : errors;
  }, {});
